var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectingImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 349,
    viewBox: "0 0 717 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M457.5 0V89.868C457.5 106.488 443.988 119.941 427.368 119.868L62.2635 118.265C29.0238 118.119 2 145.024 2 178.264V187.5M201 347H279.5M642 347H717",
    stroke: "#C9C9C9",
    strokeWidth: 3,
    strokeDasharray: "14 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingImg);
export default __webpack_public_path__ + "static/media/connectingImg.f77b147bd71df650c9101a2c8091fe2c.svg";
export { ForwardRef as ReactComponent };